import { ReactElement, useMemo } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Table, Typography } from '@weareopenr/component-library';
import { DetailedInventoryItem } from 'src/api/getInventoryItem/types';
import styles from './InventoryStepsTab.module.scss';

interface InventoryStepsTabProps {
  inventoryItem: DetailedInventoryItem;
}

type TStepRow = {
  stepId: string;
  name: string;
  stepType: string;
  displayOrder: number;
  critical: string;
};

const stepColumnHelper = createColumnHelper<TStepRow>();

const stepColumns = [
  stepColumnHelper.accessor('name', { header: 'Name' }),
  stepColumnHelper.accessor('stepType', { header: 'Type', size: 140 }),
  stepColumnHelper.accessor('critical', { header: 'Critical', size: 100 }),
];

const StepsEmptyState = () => (
  <div className={styles['table-empty-state']}>
    <Typography colour="primary">No cooking steps found</Typography>
  </div>
);

const InventoryStepsTab = ({ inventoryItem }: InventoryStepsTabProps): ReactElement => {
  const stepRows = useMemo<TStepRow[]>(
    () =>
      inventoryItem.steps?.map((step) => ({
        stepId: step.step_id,
        name: step.name,
        stepType: step.step_type,
        displayOrder: step.display_order,
        critical: step.critical ? 'Yes' : 'No',
      })) || [],
    [inventoryItem],
  );

  return (
    <div className={styles['table-container']}>
      <Table data={stepRows} columns={stepColumns} EmptyState={StepsEmptyState} />
    </div>
  );
};

export default InventoryStepsTab;
